<template>
  <div class="login">
    <v-content>
      <v-row justify="center">
        <v-col cols="12" sm="8" md="5">
          <v-card class="pb-5">
            <v-toolbar flat color="primary" dark>
                <div class="d-flex justify-center w-100">
                <v-toolbar-title class="text-h5">{{ $t("login.header") }}</v-toolbar-title>
              </div>
            </v-toolbar>
            <v-card-text class="mt-6 px-4 pt-5 justify-center text-center">
              <v-card-actions v-if="!showLoginForm" class="justify-center">
                <v-img v-if="$i18n.locale=='tc'" :style="{ cursor: 'pointer' }" src="@/assets/EdConnect Login Button_Chi.png" max-width="250" @click="redirect('https://stem-ap.polyu.edu.hk/api/edconnect/edconnect_login.php')"></v-img>
                <v-img v-else :style="{ cursor: 'pointer' }" src="@/assets/EdConnect Login Button_Eng.png" max-width="250" @click="redirect('https://stem-ap.polyu.edu.hk/api/edconnect/edconnect_login.php')"></v-img>
              </v-card-actions>
              <v-form v-if="showLoginForm" @submit="onSubmit" class="mb-6">
                
                <v-text-field
                  v-if="$i18n.locale=='tc'"
                  v-model="form.school_code"
                  label="學校編號"
                  prepend-icon="mdi-school"
                  outlined
                  dense
                  required 
                  light="light"
                />
                <v-text-field
                  v-else
                  v-model="form.school_code"
                  label="School ID"
                  prepend-icon="mdi-school"
                  outlined
                  dense
                  required 
                  light="light"
                />
                <v-text-field
                  v-if="$i18n.locale=='tc'"
                  v-model="form.username"
                  label="登入名稱"
                  prepend-icon="mdi-account"
                  outlined
                  dense
                  required 
                  light="light"
                />
                <v-text-field
                  v-else
                  v-model="form.username"
                  label="Username"
                  prepend-icon="mdi-account"
                  outlined
                  dense
                  required 
                  light="light"
                />
                <v-text-field
                  v-if="$i18n.locale=='tc'"
                  v-model="form.password"
                  label="密碼"
                  prepend-icon="mdi-lock"
                  outlined
                  dense
                  required
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                />
                <v-text-field
                  v-else
                  v-model="form.password"
                  label="Password"
                  prepend-icon="mdi-lock"
                  outlined
                  dense
                  required
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                />
                <v-btn color="primary" class="px-8 py-4" dense rounded dark  type="submit">
                  {{ $t('login.btn_login') }}
                </v-btn>
              </v-form>
              <div class="pt-5">
                <hr v-if="!showLoginForm">
                <v-btn text rounded color="secondary" @click="showLoginForm = !showLoginForm">
                  {{ showLoginForm ? $t('login.hide_login_form') : $t('login.show_login_form') }}
                </v-btn>
              </div>
            </v-card-text>
            <hr class="mx-4 mt-0 mb-5" v-if="showLoginForm"></hr>
            <v-card-actions class="justify-center" v-if="showLoginForm">
              <v-img v-if="$i18n.locale=='tc'" :style="{ cursor: 'pointer' }" src="@/assets/EdConnect Login Button_Chi.png" max-width="250" @click="redirect('https://stem-ap.polyu.edu.hk/api/edconnect/edconnect_login.php')"></v-img>
              <v-img v-else :style="{ cursor: 'pointer' }" src="@/assets/EdConnect Login Button_Eng.png" max-width="250" @click="redirect('https://stem-ap.polyu.edu.hk/api/edconnect/edconnect_login.php')"></v-img>
            </v-card-actions>
          </v-card>
        </v-col>
        <!--v-btn color="primary" class="px-8 py-4" dense dark @click="temp()">
          cookie
        </v-btn-->
      </v-row>
    </v-content>
  </div>
</template>
<script>
import moment from "moment";
import { Auth_APIService } from "@/services/Auth_APIService";
const apiService = new Auth_APIService(
  process.env.VUE_APP_BASE_URL + "/api/auth/dds/"
);
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm._backRoute = from.path
    })
  },
  name: "login",
  components: {},
  data: function () {
    return {
      form: {
        school_code: "",
        username: "",
        email: "",
        password: "",
        confirm_password: "",
      },
      options: {
        isLoggingIn: true,
      },
      showPassword: false,
      showLoginForm: false,
    };
  },

  mounted: function () {
    var self = this;
    const logoutParam = self.$route && self.$route.query ? self.$route.query.logout : null;
    const isLogout = logoutParam === "1" || logoutParam === "true" || logoutParam === true;
    // ✅ Prevent any auto-login logic if logout
    if (self.$cookies.get("auth_token") && self.$cookies.get("auth_token") != "") {
      self.$router.push("/announcement");
    }
    else if (isLogout) {
      let username = null;
			let display_name = null;
			let uid = null;
			let user_level = null;
			let school_code = null;
			let school_id = null;
			let school_name = null;
			let school_chi_name = null;
			let school_enname = null;
			let school_chname = null;
			let logged_in = false;
			let auth_token = null;
			let expiry_date = null;
			self.$store.commit("updateUserInfo", {username, user_level, school_code, school_enname, school_chname, logged_in, auth_token, uid, display_name, expiry_date});
      console.log("User just logged out - skip auto login");
      return;
    }

  },
  methods: {
    onSubmit(evt) {
      var self = this;
      evt.preventDefault();
      self.overlay = true;
      if (self.options.isLoggingIn) {
        //login
        apiService
          .login(self.form.username, self.form.password, self.form.school_code)
          .then((response) => {
            if (response.status == "fail") {
              alert(response.message);
            } else {
              sessionStorage.removeItem("justLoggedOut");
              self.$cookies.set("auth_token", response.token);
              self.$cookies.set("uid", response.uid);
              self.$cookies.set("username", response.username);
              self.$cookies.set("display_name", response.display_name);
              self.$cookies.set("user_level", response.user_level);
              self.$cookies.set("school_code", response.school_code);
              self.$cookies.set("school_enname", response.school_enname);
              self.$cookies.set("school_chname", response.school_chname);
              let username = response.username;
              let display_name = response.display_name;
              let uid = response.uid;
              let user_level = response.user_level;
              let school_code = response.school_code;
              let school_enname = response.school_enname;
              let school_chname = response.school_chname;
              let auth_token = response.token;
              let admin = false;
              let logged_in = true;
              if(user_level == "ADMIN") admin = true;
              /*self.$store.state.current.username = response.username;
              self.$store.state.current.uid = response.uid;
              self.$store.state.current.user_level = response.user_level;
              self.$store.state.current.logged_in = true;
              */
              self.$store.commit("updateUserInfo", {username, user_level, school_code, school_enname, school_chname, logged_in, auth_token, uid, display_name});
              self.$store.commit("showSnackBar", self.$t("login.login_success_prompt"));
              console.log(self._backRoute);
              if(self._backRoute == "/login" || self._backRoute == undefined || self._backRoute == "/" || self._backRoute == "/logout"){
                self.$router.go("/announcement");
                
              }
              else {
                self.$router.go(-1);
              }
            }
          });
      } else {
        //register
        apiService
          .register(
            self.form.username,
            self.form.email,
            self.form.password,
            self.form.confirm_password
          )
          .then((response) => {
            console.log("response");
            console.log(response);
            if (response.status == "fail") {
              alert(response.message);
            } else {
              self.$store.commit(
                "showSnackBar",
                "Register Success! You can login now."
              );
              self.options.isLoggingIn = true;
            }
          });
      }
    },
    redirect(url){
      window.location.href = url;
    },
    temp(){
      alert(this.$cookies.get("school_enname"))
    }
  },  
};
</script>
<style>
.login-form {
  width: 500px;
}
</style>